import React, { lazy } from 'react';
const PROOF_IMAGES = ['https://cdn.magicpatterns.com/uploads/2mZJXJ6LTcW9EtQ7sQKiEh/IMG_0208.jpg', 'https://cdn.magicpatterns.com/uploads/bY7zrN7xHFKR2ZqoK7jE3x/IMG_0209.jpg', 'https://cdn.magicpatterns.com/uploads/sDvLY1SJVdNvJSFvMk7sda/IMG_0210.jpg', 'https://cdn.magicpatterns.com/uploads/sQ4g34sRAZUQpMyZTSApkp/IMG_0212.jpg', 'https://cdn.magicpatterns.com/uploads/3hiHvyzsSgPt2HcY46Sm6W/IMG_0213.jpg', 'https://cdn.magicpatterns.com/uploads/sTJmNcPfFpjZkeUWTeC97A/IMG_0215.jpg', 'https://cdn.magicpatterns.com/uploads/rf1Tdz3taQ1WNiEVix5WLe/IMG_0216.jpg', 'https://cdn.magicpatterns.com/uploads/sYTwCYmwKgQMuXeL7Mhyr1/IMG_0217.jpg', 'https://cdn.magicpatterns.com/uploads/w3jGmcaEDQZZDfZH6SsrcH/IMG_0218.jpg', 'https://cdn.magicpatterns.com/uploads/mTbi7t9GQQGhdko6vKPWVQ/IMG_0219.jpg', 'https://cdn.magicpatterns.com/uploads/gVP3oHDaqfcKbyvuf87oHS/IMG_0220.jpg', 'https://cdn.magicpatterns.com/uploads/edrNzTAydqQRuXsm3X85J8/IMG_0221.jpg', 'https://cdn.magicpatterns.com/uploads/j2keHiwTpGKXD1GXJ8mvbY/IMG_0222.jpg', 'https://cdn.magicpatterns.com/uploads/4SxGts9o9atDbp5XUWSSyR/tempImageYQ2TS1.png'];
export function ProofCarousel({
  compact = false
}: {
  compact?: boolean;
}) {
  const imageSize = compact ? 'w-72 h-64' : 'w-96 h-80';
  const gap = compact ? 'gap-4' : 'gap-6';
  const duration = compact ? '55s' : '65s';
  // Duplicate images for seamless infinite scroll
  const allImages = [...PROOF_IMAGES, ...PROOF_IMAGES];
  return <div className="w-full overflow-hidden relative" data-id="element-266">
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-[#0A0A0A] to-transparent z-10 pointer-events-none" data-id="element-267" />
      <div className="absolute right-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-[#0A0A0A] to-transparent z-10 pointer-events-none" data-id="element-268" />

      <div className={`flex ${gap} animate-scroll`} style={{
      animationDuration: duration,
      width: 'max-content'
    }} data-id="element-269">
        {allImages.map((src, index) => <div key={index} className={`${imageSize} flex-shrink-0 rounded-xl overflow-hidden border border-[#D4A843]/30 bg-[#1A1A1A] shadow-lg shadow-black/30 p-2`} data-id="element-270">
            <img src={src} alt={`Caso de éxito ${index % PROOF_IMAGES.length + 1}`} className="w-full h-full object-contain rounded-lg" loading="lazy" data-id="element-271" />
          </div>)}
      </div>

      <style data-id="element-272">{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll linear infinite;
        }
      `}</style>
    </div>;
}